import DashboardItem from './dashboard-item';
import Card from 'tio-ui/components/card';
import Heading from 'tio-ui/components/heading';
import { t } from 'ember-intl';
import { PhConfetti, PhGear, PhSiren } from 'ember-phosphor-icons';

type ScoreIcon = typeof PhConfetti | typeof PhGear | typeof PhSiren;

/**
 * TODO: this is eventually supposed to have a link to observable document show page but
 * the custom wellness train payload doesn't include that yet; basic steps will be:
 *
 * - implement model relationships
 * - extend serializer (or maybe builder) to make association
 * - update translation and add link here with ActionableTranslation
 */

export default class WellnessInsightsDashScore extends DashboardItem {
  get scoreType() {
    return this.args.componentDefinition.name;
  }

  get icon(): ScoreIcon {
    switch (this.scoreType) {
      case 'score_on_track':
        return PhConfetti;
      case 'score_need_adjustment':
        return PhGear;
      case 'score_need_attention':
        return PhSiren;
      default:
        throw new Error(
          '@componentDefinition name prop invalid for WellnessInsightsDashScore component'
        );
    }
  }

  get iconWeight() {
    // Heavier weight for PhSiren
    return this.scoreType === 'score_need_attention' ? 'fill' : 'regular';
  }

  get typeIntent() {
    switch (this.scoreType) {
      case 'score_on_track':
        return 'tio-fg-success';
      case 'score_need_adjustment':
        return 'tio-fg-warning';
      case 'score_need_attention':
        return 'tio-fg-danger';
      default:
        throw new Error(
          '@componentDefinition name prop invalid for WellnessInsightsDashScore component'
        );
    }
  }

  get asOfDate() {
    const dateString = this.args.componentDefinition.wellnessTrain.obsUpdatedAt;
    return new Date(dateString).toLocaleDateString('en-US');
  }

  <template>
    <Card @radius="nested" @padding="sm">
      <div class="tio-col-extra-tight">
        <div class="tio-text-overline tio-row-snug tio-fg-muted">
          {{#let this.icon as |PhIcon|}}
            <PhIcon @weight={{this.iconWeight}} class="tio-icon-xs {{this.typeIntent}}" />
          {{/let}}
          {{t "wellness_insights.student_loan_insights.status_title"}}
        </div>
        <Heading @level={{2}} @size="lg" class={{this.typeIntent}}>
          {{this.translate "score.label" (hash name=this.scoreType)}}
        </Heading>
        <span class="tio-text-xs-normal tio-fg-muted">
          {{this.translate "score.as_of_date" (hash date=this.asOfDate)}}
        </span>
      </div>
    </Card>
  </template>
}
